import { Container as ChakraContainer } from '@chakra-ui/react'
import React from 'react'

interface ContainerProps {
  children: React.ReactNode
}

export const Container = ({ children, ...rest }: ContainerProps) => {
  return <ChakraContainer {...rest}>{children}</ChakraContainer>
}
